import rem from '../utils/rem';
import { IIconSizes } from './IIconSizes';

export const iconSizes: IIconSizes = {
  xsmall: rem(12),
  small: rem(16),
  medium: rem(24),
  large: rem(32),
};
